import { useState } from 'react';

import { FarIcons } from '@playbooks/icons';
import { Button } from '@playbooks/ui/components/button';
import { Popover, PopoverContent, PopoverTrigger } from '@playbooks/ui/components/popover';
import { StructuralIcon } from '@playbooks/ui/components/structural-icon';

import { ComposerActionsModel } from 'components/composer/composer-actions-model';
import { FlowFrame } from 'utils/flow';

const ComposerModelAction = ({ disabled = false, model = null, onSelect }) => {
	const [open, setOpen] = useState(false);

	// Computed
	const label = model?.name?.replace('Playbooks ', '') || 'Auto';

	// Render
	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger
				render={
					<Button variant='outline' size='xs' data-active={open} disabled={disabled} aria-label={`Model: ${label}`}>
						<StructuralIcon data-icon='inline-start' icon={FarIcons.farMicrochip} aria-hidden />
						{label}
					</Button>
				}
			/>
			<PopoverContent align='start' side='bottom' sideOffset={8} className='w-80 overflow-hidden p-0'>
				<FlowFrame layout='panel'>
					<ComposerActionsModel
						disabled={disabled}
						model={model}
						open={open}
						onClose={() => setOpen(false)}
						onSelect={onSelect}
					/>
				</FlowFrame>
			</PopoverContent>
		</Popover>
	);
};

export { ComposerModelAction };
